import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";

export default function PerfilPlantaEfluente() {
  const initialFetch = new TostadorFetching().setIdSeccion(2).setSecuencia(19);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();

  const [flujoFloculanteEstanque, setFlujoFloculanteEstanque] =
    useState(defaultObject);
  const [caudalAcidoReactor2, setCaudalAcidoReactor2] = useState(defaultObject);
  const [caudalAcidoReactor1, setCaudalAcidoReactor1] = useState(defaultObject);
  const [caudalNeutralizacion, setCaudalNeutralizacion] =
    useState(defaultObject);
  const [caudalEfluenteStripper, setCaudalEfluenteStripper] =
    useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      populateFlujoFloculanteEstanque(data);
      populateCaudalAcidoReactor2(data);
      populateCaudalNeutralizacion(data);
      populateCaudalEfluenteStripper(data);
      populateCaudalAcidoReactor1(data);
      setDateHook(data, "Flujo Floculante a Estanque");
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCaudalAcidoReactor1(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Ácido a Reactor 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCaudalAcidoReactor1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalEfluenteStripper(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Caudal Efluente Stripper"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCaudalEfluenteStripper({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalNeutralizacion(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Neutralización"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCaudalNeutralizacion({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCaudalAcidoReactor2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Caudal de Ácido a Reactor 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCaudalAcidoReactor2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateFlujoFloculanteEstanque(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Flujo Floculante a Estanque"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setFlujoFloculanteEstanque({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Planta de Efluente"}
            subtitle={"Periodo " + fullDate()}
          >
            {/** -------------------------------- Flujo Floculante a Estanque --------------------------------------- */}
            <Chart.Line
              name="Flujo Floculante a Estanque"
              data={flujoFloculanteEstanque.value}
              yAxis={0}
            />

            {/** -------------------------------- Caudal de Ácido a Reactor 2 --------------------------------------- */}
            <Chart.Line
              name="Caudal de Ácido a Reactor 2"
              data={caudalAcidoReactor2.value}
              yAxis={0}
            />

            {/** -------------------------------- Caudal de Ácido a Reactor 1 --------------------------------------- */}
            <Chart.Line
              name="Caudal de Ácido a Reactor 1"
              data={caudalAcidoReactor1.value}
              yAxis={0}
            />

            {/** -------------------------------- Caudal de Neutralización --------------------------------------- */}
            <Chart.Line
              name="Caudal de Neutralización"
              data={caudalNeutralizacion.value}
              yAxis={1}
            />

            {/** -------------------------------- Caudal Efluente Stripper --------------------------------------- */}
            <Chart.Line
              name="Caudal Efluente Stripper"
              data={caudalEfluenteStripper.value}
              yAxis={1}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={flujoFloculanteEstanque.fecha} />

            <Chart.YAxis
              labelSuffix=" m3/h"
              title="Caudal: Floculante, Ácido a Reactores"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={15}
            />

            <Chart.YAxis
              labelSuffix=" m3/h"
              title="Caudal: Neutralización y Efluente Stripper"
              lineWidth={2}
              lineColor="white"
              opposite={true}
              min={0}
            />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
